import * as React from "react";
const SvgCamera = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={35}
    fill="none"
    {...props}
  >
    <path
      stroke="#89909D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M21.29 1.5h-2.58c-1.322 0-1.983 0-2.576.207a3.7 3.7 0 0 0-1.008.54c-.501.378-.868.928-1.601 2.028-.376.564-.93 1.394-1.15 1.626a3.7 3.7 0 0 1-2.045 1.094c-.315.055-.654.055-1.33.055-1.814 0-2.72 0-3.462.21A5.55 5.55 0 0 0 1.71 11.09c-.21.74-.21 1.647-.21 3.46v7.301c0 5.233 0 7.849 1.626 9.475S7.367 32.95 12.6 32.95h14.8c5.233 0 7.849 0 9.474-1.625S38.5 27.083 38.5 21.85v-7.3c0-1.814 0-2.72-.21-3.461a5.55 5.55 0 0 0-3.828-3.829c-.742-.21-1.648-.21-3.461-.21-.677 0-1.016 0-1.331-.055a3.7 3.7 0 0 1-2.045-1.094c-.22-.232-.774-1.062-1.15-1.626-.733-1.1-1.1-1.65-1.601-2.028a3.7 3.7 0 0 0-1.008-.54C23.273 1.5 22.612 1.5 21.29 1.5"
    />
    <path
      stroke="#89909D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M27.4 19.075a7.4 7.4 0 1 1-14.8 0 7.4 7.4 0 0 1 14.8 0"
    />
  </svg>
);
export default SvgCamera;
